import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

export const SCHEDULE_LABELS_FR = {
  day: 'Jour',
  week: 'Semaine',
  month: 'Mois',
  year: 'Année',
  allDay: 'Journée',
  weekday: 'Jour',
  timeSlot: 'Créneau',
  today: 'Aujourd\'hui',
  next: 'Suivant',
  previous: 'Précédent',
  more: 'Plus',
  selectMonth: 'Choisir un mois',
  selectYear: 'Choisir une année',
  switchToDayView: 'Vue jour',
  switchToWeekView: 'Vue semaine',
  switchToMonthView: 'Vue mois',
  switchToYearView: 'Vue année',
  viewSelectLabel: 'Vue',
  noEvents: 'Aucun événement',
  moreLabel: (count) => `+${count} de plus`,
};

export function getPlanningRange(date, view) {
  const d = dayjs(date);
  switch (view) {
    case 'day':
      return { from: d.startOf('day'), to: d.endOf('day') };
    case 'week':
      return { from: d.startOf('isoWeek'), to: d.endOf('isoWeek') };
    case 'month':
      return { from: d.startOf('month'), to: d.endOf('month') };
    case 'year':
      return { from: d.startOf('year'), to: d.endOf('year') };
    default:
      return { from: d.startOf('isoWeek'), to: d.endOf('isoWeek') };
  }
}

const RDV_STATUS_COLORS = {
  pending: 'orange',
  accepted: 'blue',
  declined: 'red',
};

const RDV_STATUS_LABELS = {
  pending: 'En attente',
  accepted: 'Accepté',
  declined: 'Refusé',
};

export function resolveRdvEventColor(entry) {
  if (entry.type !== 'rdv') {
    return entry.event_color || 'teal';
  }
  if (entry.client_rdv_status && RDV_STATUS_COLORS[entry.client_rdv_status]) {
    return RDV_STATUS_COLORS[entry.client_rdv_status];
  }
  return entry.event_color || 'blue';
}

export function resolveRdvEventTitle(entry) {
  const base = entry.display_title || entry.category_label || entry.client_label || 'Événement';
  if (entry.type !== 'rdv' || !entry.client_rdv_status) return base;
  const statusLabel = RDV_STATUS_LABELS[entry.client_rdv_status];
  return statusLabel ? `${base} (${statusLabel})` : base;
}

export function crmEntryToScheduleEvent(entry) {
  const start = dayjs(entry.occurred_at);
  const duration = Number(entry.duration_minutes) > 0 ? Number(entry.duration_minutes) : 60;
  const end = start.add(duration, 'minute');

  return {
    id: entry.id,
    title: resolveRdvEventTitle(entry),
    start: start.format('YYYY-MM-DD HH:mm:ss'),
    end: end.format('YYYY-MM-DD HH:mm:ss'),
    color: resolveRdvEventColor(entry),
    payload: {
      client_id: entry.client_id,
      client_label: entry.client_label,
      category_id: entry.category_id,
      category_label: entry.category_label,
      type: entry.type,
      infos: entry.infos,
      duration_minutes: duration,
      link_mode: entry.category_id ? 'category' : 'client',
      client_rdv_status: entry.client_rdv_status || null,
      client_rdv_message: entry.client_rdv_message || null,
    },
  };
}
